var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowTwoSides = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowTwoSides_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.75 7.98H5.02v-.01c-.55 0-1-.45-1-1s.45-1 1-1h11.73l-2.23-2.31a.996.996 0 0 1 .03-1.41.987.987 0 0 1 1.41.02l3.86 4c.38.39.38 1 0 1.39l-3.86 4a1 1 0 0 1-1.42.03c-.39-.38-.4-1.01-.02-1.41zm-9.3 7.99h11.66l-.02.01c.55 0 1 .45 1 1s-.45 1-1 1H7.34l2.33 2.44c.38.4.37 1.03-.03 1.41-.19.19-.44.28-.69.28-.26 0-.52-.1-.72-.31l-3.94-4.13a.993.993 0 0 1 .02-1.4l4.1-4.06c.4-.4 1.03-.39 1.42 0 .4.39.39 1.02 0 1.41z",
  clipRule: "evenodd"
})));
export default SvgArrowTwoSides;